import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { compose } from '@reduxjs/toolkit';
import { useDispatch, connect } from 'react-redux';

import Pagination from 'core/pagination/Pagination';
import { setRefundLogsParam } from 'app/features/transactions/zaiTransactionSlice';

function RefundLogPagination({ totalCount, pageSize, pageNumber }) {
  const dispatch = useDispatch();

  return (
    <Box component="div" sx={{ py: 2 }}>
      <Pagination
        count={Math.ceil(totalCount / pageSize)}
        page={pageNumber}
        onChange={(currentPage) => dispatch(setRefundLogsParam({ page_number: currentPage }))}
        onRowPerPageChange={(rowPerPage) =>
          dispatch(setRefundLogsParam({ page_size: rowPerPage, page_number: 1 }))
        }
        perPageValue={pageSize}
      />
    </Box>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    totalCount: state.zaiTransactions.refundLogs.totalCount,
    pageSize: state.zaiTransactions.refundLogs.params.PageSize,
    pageNumber: state.zaiTransactions.refundLogs.params.PageNumber,
  };
}

export default compose(connect(mapStateToProps))(RefundLogPagination);

RefundLogPagination.propTypes = {
  pageSize: PropTypes.number,
  totalCount: PropTypes.number,
  pageNumber: PropTypes.number,
};
